import React from 'react';
import {
  CircularProgress,
  CircularProgressProps,
  Theme,
  withStyles,
} from '@material-ui/core';

export default withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
  },
}))((props: CircularProgressProps) => (
  <CircularProgress
    {...props}
    style={{
      marginTop: props.size ? +props.size * -0.5 : undefined,
      marginLeft: props.size ? +props.size * -0.5 : undefined,
    }}
  />
));
